export const styles = theme =>({
    checkboxes: {
        marginTop: 32,
    },
    summary: {
        margin: "3rem 0 1.5rem 0",
        fontWeight: 600,
        "& h2": {
            fontSize: "1.6rem",
            fontWeight: 600,
        }
    },
});